export function saveLoginInfo(info) {
    localStorage.setItem("login_info", JSON.stringify(info));
}

export function getLoginInfo(key = null) {
    return JSON.parse(localStorage.getItem("login_info"));
}
